var _path, _path2, _path3, _text, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductBuilderTemplateSpiralNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2504,
    height: 3531,
    fill: "none",
    viewBox: "0 0 2504 3531",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 1,
    stroke: "red",
    d: "M190.26 98h2232.82v3335H190.26V98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 1,
    stroke: "#0080FF",
    d: "M34.75 61.32h2425v3408.37h-2425z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M170.1 104.2H110v60.12h60.1V104.2Zm0 425.55H110v60.1h60.1v-60.1ZM110 955.29h60.1v60.11H110v-60.11Zm60.1 425.54H110v60.11h60.1v-60.11ZM110 1806.37h60.1v60.11H110v-60.11Zm60.1 425.54H110v60.11h60.1v-60.11ZM110 2657.45h60.1v60.11H110v-60.11Zm60.1 425.54H110v60.11h60.1v-60.11ZM110 246.05h60.1v60.11H110v-60.1Zm60.1 425.55H110v60.1h60.1v-60.1ZM110 1097.13h60.1v60.11H110v-60.11Zm60.1 425.54H110v60.11h60.1v-60.11ZM110 1948.22h60.1v60.1H110v-60.1Zm60.1 425.54H110v60.1h60.1v-60.1ZM110 2799.3h60.1v60.1H110v-60.1Zm60.1 425.54H110v60.11h60.1v-60.11ZM110 387.9h60.1v60.11H110v-60.1Zm60.1 425.54H110v60.1h60.1v-60.1ZM110 1238.98h60.1v60.11H110v-60.11Zm60.1 425.54H110v60.11h60.1v-60.11ZM110 2090.06h60.1v60.11H110v-60.11Zm60.1 425.54H110v60.11h60.1v-60.11ZM110 2941.14h60.1v60.11H110v-60.11Zm60.1 425.54H110v60.11h60.1v-60.11Z",
    opacity: 0.25
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 1200,
    y: 160
  }, "Safe area")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    text {\r\n      font-family:sans-serif;\r\n      fill: red;\r\n      font-size: 50px;\r\n      paint-order: stroke;\r\n      stroke: #fff;\r\n      stroke-width: 20px;\r\n      stroke-linecap: butt;\r\n      stroke-linejoin: round;\r\n      opacity: .66;\r\n      text-align: center;\r\n    }\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBuilderTemplateSpiralNotebook);
export default __webpack_public_path__ + "static/media/product-builder-template_spiral-notebook.73e17e6424dfd2a42bc67fa8f8bedef7.svg";
export { ForwardRef as ReactComponent };